import { BidStatusFilterLabel } from '../../../helpers/filters/filter-types';
import { isDefined } from '../../../utils/utils';
import { ValueGetterParamsDealVersion } from './value-getters.interface';

export function bidSubmittedValueGetter({
  data
}: ValueGetterParamsDealVersion): BidStatusFilterLabel {
  // Handle null or undefined values
  if (!isDefined(data)) {
    return undefined;
  }

  return data.bidSubmitted
    ? BidStatusFilterLabel.submitted
    : BidStatusFilterLabel.notSubmitted;
}
